import { useEffect, useState } from "react";
import TitlePage from "../../../components/TitlePage";
import { Row, Col, Button } from "react-bootstrap";
import { ConsultaTotvsEmpresa } from "../../../../backend/ConsultaTotvsEmpresa";
import ResponsiveDataTable from "../../../components/DataTable";
import LoadingSpinner from "../../../components/LoadinSpinner";

import TipoBMSI from "../../../../lib/json/consultas/TipoBMSI.json"
import SelectEmpresa from "../../../components/Select/Empresa";
import { ErroMsg, SucessoMsg } from "../../../contents/VariaveisGlobais";
import { useNavigate } from "react-router-dom";
import { usePopUp } from "../../../components/BootBox";
import ConsumoTOTVS_POST from "../../../../backend/ConsumoTotvs";
import { useSessionStorageState } from "../../../../hooks/useSessionStorageState";

function ListaTipoBMSI(){
    const { DisparaBootBox, FechaBootBox  } = usePopUp();
    // define a exibição do Loading
    var tabelasDefault  = TipoBMSI.tabelas;
    
    const navigate = useNavigate();
    
    const [carregar, setCarregar] = useState(false);
    const [data, setData]   = useState([]);
    const [empresa, setEmpresa] = useSessionStorageState("TipoBMSIEmpresa", {value: "",text: "", });

    // Colunas do grid
    const columns = [
        {
            Header: 'ID',
            accessor: "PZ1_ID",
        },
        {
            Header: 'Descrição',
            accessor: "PZ1_DESCRI",
            Cell: (item) => { 
                return (
                    <>
                        {item.value}
                        <br/><strong>Tipo: </strong> {item.row.original.PZ1_CONTAB}
                    </>
                )
            }
        },
        {
            Header: 'Conta Contábil - OverHead',
            accessor: "PZ1_CONTCR",
            Cell: (item) => { 
                const { PZ1_CCDEBI, PZ1_CCCRED } = item.row.original
                return (
                    <>
                        <p><strong>Crédito: </strong> {PZ1_CCCRED}</p>
                        <p><strong>Débito: </strong> {PZ1_CCDEBI}</p>
                    </>
                )
            }
        },
        {
            Header: 'Conta Contábil - Operacional',
            accessor: "PZ1_CCDBIC",
            Cell: (item) => { 
                const { PZ1_CCDBIC, PZ1_CCCDIC} = item.row.original
                return (
                    <>
                        <p><strong>Crédito: </strong> {PZ1_CCCDIC}</p>
                        <p><strong>Débito: </strong> {PZ1_CCDBIC}</p>
                    </>
                )
            }
        },
    ];

    // Processa consulta do grid
    const listaTipoBMSI = async () => {
        var consultaDefault = TipoBMSI.consulta;
        let empresaFilial = empresa.value ? empresa.value.substr(0,window._env_?.REACT_APP_TAMANHO_EMPRESA) + '-' + empresa.value.substr(-window._env_?.REACT_APP_TAMANHO_FILIAL) : ''

        setCarregar(true);
        var retConsulta = await ConsultaTotvsEmpresa( consultaDefault, tabelasDefault, empresaFilial );
        
        if (retConsulta){
            setData(retConsulta.data);
        } 

        setCarregar(false);
    }

    useEffect( () => {
        listaTipoBMSI()
    },[])

    const handleAlterar = (row) =>{
        navigate(`./Alterar/${row.values.PZ1_ID}/${row.original.EMPRESA}${row.original.M0_CODFIL}`)
    }
    
    const handleVisualizar = (row) =>{
        navigate(`./Visualizar/${row.values.PZ1_ID}/${row.original.EMPRESA}${row.original.M0_CODFIL}`)
    }
    
     const handleExcluir = async (row) => {
        const idRow = row.original.EMPRESA + '' + row.original.M0_CODFIL + '|' + row.original.PZ1_ID;
        const Mensagem = `Tem certeza que deseja excluir o Tipo de BMSI ${row.original.PZ1_ID}?`
        
        DisparaBootBox('Confirma Exclusão ?', Mensagem, null, idRow, handleExcluirConfirm)
    };

    const handleExcluirConfirm = async(row) => {
        const empresaFilial = row.split('|')[0]
        const cJSONSalvar = { 
            ACAO: 'EXCLUIR',
            PZ1_ID: row.split('|')[1] 
        }

        FechaBootBox()
        try {
            setCarregar(true);

            const oRetorno = await ConsumoTOTVS_POST('TIPOBMSI', cJSONSalvar, empresaFilial)
            
            if (oRetorno.error === '00'){
                SucessoMsg(oRetorno.description)
            }else{
                ErroMsg(oRetorno.description)
                return false;
            }
        } catch (error) {
            console.error('Error in handleExcluir:', error);
            // Handle the error, show an error message, or log it as needed.
        } finally {
            setCarregar(false);
            listaTipoBMSI();
        }
    };

    return (
        <>
            <Row>
                <LoadingSpinner isLoading={carregar}/>
                <Col md="12" xs="12">
                    <TitlePage text="Tipo de BMSI"/>
                </Col>
                <Col md='4'>
                    <SelectEmpresa
                        campoEmpresa={empresa}
                        onChangeEmpresa={setEmpresa}
                    />
                </Col>                
            </Row>
            <Row className="d-flex justify-content-end">
                <Col md="3" xs="12">
                    <Button 
                        variant="outline-primary" 
                        type="submit" 
                        onClick={listaTipoBMSI}
                        className="w-100"
                    >
                        Buscar
                    </Button>
                </Col>
            </Row>
            
            <Row>
                <Col md="12" xs="12">
                    <ResponsiveDataTable 
                        columns={columns} 
                        data={data} 
                        buttons={[
                            {isVisual: true, action: handleVisualizar, label: "Visualizar", icone: "MdOutlinePreview", style: "light"}, 
                            {isAlterar: true, action: handleAlterar, label: "Alterar", icone: "MdOutlineEditNote" }, 
                            {isExcluir: true, action: handleExcluir, label: "Excluir", icone: "MdPlaylistRemove", style: "danger" }
                        ]}
                    />
                </Col>
            </Row>
        </>
    );
}

export default ListaTipoBMSI;